import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, Row, Col, Select, Spin, Space } from 'antd';
import { get, save, setPending } from '../redux/actions/establecimientoActions';
import {
  ExclamationCircleOutlined,
  DeleteFilled,
  EditFilled,
  PlusOutlined,
} from '@ant-design/icons';
import { compareObject } from '../utils/funtions';
import { callStatus } from '../utils/constants';
import MetaTable from './base/MetaTable';
import cloneDeep from 'lodash/cloneDeep';
import { Notificacion } from './Notificacion';
import PropietarioEditor from './PropietarioEditor';
import { setPending as setPendingPropietario } from '../redux/actions/propietarioActions';

import {
  DraggableModal,
  DraggableModalProvider,
} from 'ant-design-draggable-modal';
const { Option } = Select;

const { confirm } = Modal;

const EstablecimientoEditor = ({
  dispatch,
  id,
  stateData,
  visible,
  onCancel,
  propietario,
}) => {
  const [form] = Form.useForm();

  const [showEditPropietario, setShowEditPropietario] = useState(false);
  const [propietarioId, setPropietarioId] = useState(null);

  const handleEditPropietario = (id) => {
    setPropietarioId(id);
    setShowEditPropietario(true);
  };

  const handleHideEditorPropietario = () => {
    setShowEditPropietario(false);
    setPropietarioId(null);
    dispatch(setPendingPropietario());
  };

  useEffect(() => {
    if (id) {
      if (String(stateData.object.data?.id) !== String(id)) {
        dispatch(get(id));
      }
    } else {
      dispatch(setPending());
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      propietario.object.status === callStatus.OBJECT_SAVE_SUCCESS &&
      showEditPropietario
    ) {
      const savedPropietario = propietario.object.data;
      if (!propietarioId) {
        setPropietarios((prev) => {
          if (!prev.some((p) => p.propietario_id === savedPropietario.id)) {
            return [
              ...prev,
              {
                propietario_id: savedPropietario.id,
                propietario_nombre: savedPropietario.nombre,
              },
            ];
          }
          return prev;
        });
      } else {
        setPropietarios((prev) =>
          prev.map((p) =>
            p.propietario_id === savedPropietario.id
              ? { ...p, propietario_nombre: savedPropietario.nombre }
              : p
          )
        );
      }
    }
  }, [
    propietario.object.status,
    showEditPropietario,
    propietarioId,
    propietario.object.data,
  ]);

  useEffect(() => {
    let data = cloneDeep(stateData.object.data);
    if (stateData.object.status === callStatus.OBJECT_SUCCESS) {
      if (data.propietarios) {
        setPropietarios(data.propietarios);
      }

      form.setFieldsValue(data);
      setInitial(data);
    } else if (stateData.object.status === callStatus.OBJECT_PENDING) {
      form.resetFields();
      setInitial({});
      setPropietarios([]);
    } else if (stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) {
      Notificacion('El registro se guardó con éxito', 'success', onCancel);
    } else if (stateData.object.status === callStatus.OBJECT_FAILED) {
      Notificacion(stateData.object.error, 'error', () => {});
    }

    // eslint-disable-next-line
  }, [stateData.object]);

  const onCreate = (data) => {
    dispatch(save(data));
  };

  const [initial, setInitial] = useState({});

  const handleOnCancel = () => {
    if (compareObject(initial, form.getFieldsValue())) {
      confirm({
        title: 'Posee cambios sin guardar, desea continuar?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Si',
        cancelText: 'No',
        autoFocusButton: 'cancel',
        onOk() {
          onCancel();
        },
        onCancel() {},
      });
    } else {
      onCancel();
    }
  };

  const handleDelete = (data) => {
    setPropietarios((prev) =>
      prev.filter((item) => item.propietario_id !== data.propietario_id)
    );
  };

  const handleConfirmDelete = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const onSuperficiePropietarioChange = (e, key, index, record) => {
    let newData = [...propietarios];
    newData = [
      ...newData.map((item) => {
        if (item.propietario_id === record.propietario_id) {
          return { ...item, superficie: e.target.value };
        } else {
          return item;
        }
      }),
    ];

    setPropietarios(newData);
  };

  const [propietarios, setPropietarios] = useState([]);
  const columnsPropietario = [
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled
            onClick={() => handleEditPropietario(record.propietario_id)}
          />
          <DeleteFilled onClick={() => handleConfirmDelete(record)} />
        </Space>
      ),
      width: 60,
    },
    {
      ellipsis: true,
      title: 'Nombre',
      dataIndex: 'propietario_nombre',
    },
    {
      width: 150,
      title: 'Superficie Ha',
      dataIndex: 'superficie',
      render: (text, record, index) => (
        <Input
          type="number"
          value={text}
          onChange={(e) =>
            onSuperficiePropietarioChange(e, 'superficie', index, record)
          }
        />
      ),
    },
  ];

  const [propietarioData, setPropietarioData] = useState([]);

  useEffect(() => {
    setPropietarioData(propietario.list.data);
    // eslint-disable-next-line
  }, [propietario]);

  const [resultSearchPropietario, setResultSearchPropietario] = useState([]);

  const onSearchPropietario = (value) => {
    const result = propietarioData.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase())
    );
    setResultSearchPropietario(result);
  };

  const onChangePropietario = (value) => {
    const result = propietarioData.find((item) => item.id === value);

    setPropietarios([
      ...propietarios,
      { propietario_id: result.id, propietario_nombre: result.nombre },
    ]);

    setResultSearchPropietario([]);
    form.setFieldsValue({
      search_propietario_id: null,
    });
  };

  useEffect(() => {
    form.setFieldsValue({
      propietarios: propietarios,
    });
    // eslint-disable-next-line
  }, [propietarios]);

  return (
    <>
      <DraggableModalProvider>
        <DraggableModal
          mask
          initialWidth={600}
          initialHeight={700}
          maskClosable={false}
          visible={visible}
          title={
            stateData.object.data.id
              ? 'Editar Establecimiento'
              : 'Nuevo Establecimiento'
          }
          okText="Guardar"
          cancelText="Salir"
          onCancel={handleOnCancel}
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                onCreate(values);
              })
              .catch((info) => {
                console.log('Validate Failed:', info);
              });
          }}
        >
          <Spin
            spinning={
              stateData.object.status === callStatus.OBJECT_IN_PROCESS ||
              !!(id && stateData.object.status === callStatus.OBJECT_PENDING)
            }
          >
            <Form form={form} layout="vertical" name="form_in_modal">
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="id" label="id" style={{ display: 'none' }}>
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="propietarios"
                    label="propietarios"
                    style={{ display: 'none' }}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    name="nombre"
                    label="Nombre"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                  <Form.Item name="superficie" label="Superficie">
                    <Input type="number" addonBefore="ha" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                  <Form.Item name="ubicacion" label="Ubicación">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[8, 0]} align="middle">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item
                      label="Propietarios"
                      name="search_propietario_id"
                      style={{
                        flex: 1,
                      }}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={onSearchPropietario}
                        onChange={onChangePropietario}
                        notFoundContent={null}
                        allowClear
                        placeholder="Buscar Propietario"
                      >
                        {resultSearchPropietario.map((item, index) => (
                          <Option key={index} value={item.id}>
                            {item.nombre}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <div style={{ marginTop: '5px' }}>
                      <PlusOutlined
                        onClick={() => {
                          setPropietarioId(null);
                          setShowEditPropietario(true);
                        }}
                        style={{ paddingLeft: '7px', cursor: 'pointer' }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Form.List
                  name="propietarios"
                  rules={[
                    {
                      validator: async (_, propietarios) => {
                        if (!propietarios || propietarios.length < 1) {
                          return Promise.reject(
                            new Error('Seleccione al menos un propietario')
                          );
                        }
                      },
                    },
                  ]}
                >
                  {(fields, { add, remove }, { errors }) => (
                    <>
                      {errors.length > 0 && (
                        <Row
                          gutter={[0, 0]}
                          style={{ width: '100%' }}
                          align="top"
                          justify="center"
                        >
                          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item>
                              <Form.ErrorList errors={errors} />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                </Form.List>
                {propietarios && propietarios.length > 0 && (
                  <MetaTable
                    dataSource={propietarios}
                    dataColumns={columnsPropietario}
                    bordered={false}
                    selection={false}
                    cssStyle={true}
                  />
                )}
              </Row>
            </Form>
          </Spin>
        </DraggableModal>
        {showEditPropietario ? (
          <PropietarioEditor
            id={propietarioId}
            onCancel={handleHideEditorPropietario}
            visible={true}
          />
        ) : (
          false
        )}
      </DraggableModalProvider>
    </>
  );
};

const mapStateToProps = (state) => {
  const { establecimiento, propietario } = state;
  const stateData = establecimiento;
  return {
    stateData,
    propietario,
  };
};
export default connect(mapStateToProps)(EstablecimientoEditor);
